/* global _SENTRY_DSN_ */
/* eslint-disable */
// Define assets path "On The Fly"
__webpack_public_path__ = window.inx.params.project.path.assets;
/*eslint-enable */

import { ROUTER_PAGES } from 'newJs/config';
import execShared from 'src/js/modules/shared';
import mainjs from 'src/js/main';
import inx from 'inx';
import { init, captureException } from '@sentry/browser';

if (_SENTRY_DSN_) {
    //for dynamic regexes RegExp object is required
    // eslint-disable-next-line no-useless-escape
    const emailHost = new RegExp('https?:\/\/' + inx.params.hostName.replace('.', '\\.'));
    // eslint-disable-next-line no-useless-escape
    const assetHost = /https?:\/\/pform\.net/;

    init({
        dsn: _SENTRY_DSN_,
        ignoreErrors:[
            'TypeError: Failed to fetch',
            'Non-Error exception captured',
            'Non-Error promise rejection captured',
            'Object captured as promise rejection with keys: abort, always, catch, done, fail', //jquery ajax fail
            '[Launcher] ERROR:  Launcher: error loading configuration'
        ],
        // tracesSampleRate: 0.2,
        allowUrls: [emailHost, assetHost],
        denyUrls: [
            'b.adbox.lv',
            'google',
            'doubleclick',
            'btloader.com',
            'securepubads.g.doubleclick.net',
            /graph\.facebook\.com/i,
            /extensions\//i,
            /^chrome:\/\//i,
            /ed4/i,
        ],
        initialScope: {
            user: { email: inx.params.user.email },
        },
        //not always called so we need to filter also https://github.com/getsentry/sentry-javascript/pull/3371
        beforeSend: (event, hint) => {

            //attempt to add additional info to the event
            //https://github.com/getsentry/sentry-javascript/issues/2210
            if (hint && hint.originalException instanceof Event) {
                event.extra.isTrusted = hint.originalException.isTrusted;
                event.extra.detail = hint.originalException.detail;
                event.extra.type = hint.originalException.type;
            }

            //skip ckeditor4 errors
            const error = hint.originalException;
            if (
                error &&
                error.stack &&
                error.stack.includes('/ed4/')
            ) {
                return null;
            }

            return event;
        },
    });
}
/* eslint-disable no-console */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
const _error = console.error;
console.error = function () {
    let logError = true;
    let err = arguments[0];
    if (err?.responseJSON && err?.responseJSON.error_description.includes('Wrong password')) return;
    if ((err instanceof Error)) {
        if (err.stack) {
            if (err.stack.includes('/ed4/')) {
                logError = false;
            }
        }
    } else {
        //do not log such things as console.error("test")
        logError = false;
        //we can not reliably here check if this is from 3rdparty site
    }

    //disable logging errors from 3rd-party hosts
    try {
        const stackTrace = new Error().stack;
        const stackList = stackTrace.split('\n');
        const stackObjList = stackList.map((item) => {
            if (!item) {
                return {};
            }

            const fileData = item.split('@')[1];
            if (!fileData) {
                return {};
            }
            const fileParts = fileData.split(':');

            return {
                'function': item.split('@')[0],
                'file': fileParts.slice(0, -2).join(''),
                'line': fileParts[fileParts.length - 2],
                'line_no': fileParts[fileParts.length - 1],
            };
        }).filter(element => Object.keys(element).length > 0);
        if (stackObjList[1]) {
            const link = stackObjList[1].file;
            if (
                !link.includes(inx.params.standard.path) &&
                !link.includes(inx.params.project.path.assets)
            ) {
                logError = false;
                console.log('skipped logging error from 3rd-party host ' + link, err);
            }
        }
        if (typeof err !== 'string') {
            err.customTrace = stackObjList;
        }
    } catch (e) {
        if (typeof err !== 'string') {
            err.customTrace = 'could not parse stack trace, error: '+ e.message;
        }
        console.log('could not parse stack trace', e);
    }

    if (logError) {
        captureException(err);
        return _error.apply(console, arguments);
    } else {
        //convert error to log, so it is really not logged in sentry
        console.log.apply(null, arguments);
    }
};

const preparePages = (obj, INBOX) => ({
    ['router-pages']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "router-pages" */
            './mainRouter'
        );
        init();
    },

    ['advanced-search']() {
        import(
            /* webpackChunkName: "page_advanced-search" */
            'src/js/pages/advanced-search'
        ).then(({ default: init }) => {
            const params = obj.mail.params['advanced-search'];
            init(INBOX, obj, params);
        });
    },

    ['contacts-builder']() {
        import(
            /* webpackChunkName: "page_contacts-builder" */
            'src/js/pages/contacts-builder'
        ).then(({ default: init }) => {
            const params = obj.mail.params.contactsBuilder;
            init(INBOX, obj.mail.fn);
            new INBOX.classes.contactsBuilder(params);
        });
    },

    ['aliases']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-aliases" */
            'src/js/pages/options/aliases'
        );
        init(INBOX, obj);
    },

    ['options-filters']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-filters" */
            'src/js/pages/options/filters'
        );
        const params = obj.mail.params.filters;
        init(INBOX, params, obj.i18n);
    },

    ['options-forwarding']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-forwarding" */
            'src/js/pages/options/forwarding'
        );
        init(INBOX, obj);
    },

    ['options-folders']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-folders" */
            'containers/Options/Folders'
        );
        init(INBOX, obj);
    },

    ['options-recover-optimize']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-recovery-optimize" */
            'src/js/pages/options/recover-optimize'
        );
        const { recoveryOptimize } = obj.mail.params;
        init(INBOX, recoveryOptimize);
    },

    ['options-signature']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-signature" */
            'src/js/pages/options/signature'
        );
        init(INBOX, obj);
    },

    ['options-spam-protection']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-spam-protection" */
            'containers/Options/SpamProtection'
        );
        const { spamProtection } = obj.mail.params;
        init(INBOX, spamProtection);
    },

    ['options-autoreply']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-autoreply" */
            'src/js/pages/options/autoreply'
        );
        init(obj.mail.params.pageData);
    },

    ['options-labels']: async () => {
        const { default: init } = await import(
            /* webpackChunkName: "page_options-labels" */
            'containers/Options/Labels'
        );
        init(INBOX, obj);
    },
});

((args) => {
    // console.dir(args);
    const { inx, INBOX, mainJs: fnc } = args;
    const mail = inx.mail || {};
    const mailParams = mail.params || {};
    const getPage = preparePages(inx, INBOX);

    // TODO: will need use React flashMessage
    // wrap this on DOM load as it is js function, to wait till all page are loaded
    window.onload = function() {
        const relativePath = window.location.pathname ;
        const reactUrls = ['/mailbox', '/compose', '/reply', '/forward', '/message'];
        const doesNotContainUrl = reactUrls.every(url => !relativePath.startsWith(url));

        // show only in option pages
        if (inx.mail.flashMessages.length > 0 && doesNotContainUrl) {
            const targetElement = document.getElementById('js-options-page');

            inx.mail.flashMessages.forEach(function(obj) {
                let message = document.createElement('div');
                message.innerHTML = obj.text;
                // Set class using className
                message.className = 'alert alert_has-icon alert-dismissible alert-' + obj.type;
                // Apply margin
                message.style.margin = '.5em 0 0';
                // check if this old navigation is defined - (js-options-page used only filled in options page)
                if (targetElement.children.length) {
                    // Insert message as the first child of targetElement
                    targetElement.insertBefore(message, targetElement.firstChild);
                }
            });
        }
    };


    //todo use only react router for this
    const currentPageName = mailParams.pageName;
    mail.fn = fnc;
    // console.info('Current page: %s', currentPageName);
    // Initialize site-wide functions
    execShared(inx, INBOX);

    // Set legacy params
    try {
        if (currentPageName) {
            fnc.setParam(mailParams[currentPageName], currentPageName);
        } else {
            fnc.setParam(mailParams[currentPageName]);
        }
        // console.dir(fnc.getParam(currentPageName));
    } catch (e) {
        // console.warn(e);
    }

    if (currentPageName && Object.prototype.hasOwnProperty.call(getPage, currentPageName)) {
        // console.info('We have handler for %s page!', currentPageName);
        getPage[currentPageName]();
    }
    if (!currentPageName || ROUTER_PAGES.includes(currentPageName)) {
        getPage['router-pages']();
    }
})(mainjs);
